import React from 'react';
import { Images, renderStaffName, staffStatusEnums, staffStatuses, tagEnums } from 'utils';
import { PhoneRow, TextRow, FullNameRow, DateRow, TagComponent, StatusCard, FilterTags, NavigateCalendar } from 'components';
import { canReadTags } from 'store/tags/tag.utils';

export const staffDefaultStatuses = [
    staffStatusEnums.ACTIVE,
    // staffStatusEnums.INACTIVE,
    staffStatusEnums.HOLD,
    // staffStatusEnums.ON_LEAVE,
];

export const staffHead = (deps) => {
    return [
        { name: 'fullName', title: 'Full Name', searchKey: 'NAME' },
        {
            name: 'department',
            title: 'Department',
            disabled: true,
            multiple: true,
            filterList: [{ name: 'All', id: 'All' }, { name: '--', id: '--' }, ...deps],
        },
        { name: 'jobTitle', title: 'Job Title', disabled: true },
        { name: 'email', title: 'Email Address', searchKey: 'EMAIL', custom: false },
        { name: 'phone', title: 'Phone Number', searchKey: 'PHONE', custom: false, width: '150px' },
        { name: 'hiredDate', title: 'Hired Date', iconType: 'date', width: '115px' },
        // Falsy head/body entries are skipped by the table, so the Tags column disappears entirely
        // for a user with neither TAG_READ nor TAG_MANAGE — rather than leaving a blank strip.
        canReadTags() && { name: '', title: 'Tags', custom: false, renderView: <FilterTags /> },
        {
            name: 'statuses',
            title: 'Status',
            disabled: true,
            width: '120px',
            multiple: true,
            filterList: [{ name: 'All', id: 'All' }, ...staffStatuses],
            defaultSelected: staffDefaultStatuses,
        },
        { name: '', title: 'Action', custom: false, width: '60px' },
    ];
};
export const staffBody = (requestParams, afterSuccess) => [
    {
        rowText: (item) => (
            <div className="info-and-avatar">
                <div className="avatar-box">
                    {item?.avatar?.url ? (
                        <img src={item?.avatar?.url} alt={''} />
                    ) : (
                        `${item?.firstName?.slice(0, 1)}${item?.lastName?.slice(0, 1)}`
                    )}
                </div>
                <TextRow name={renderStaffName(item)} textWidth={7} />
            </div>
        ),
    },
    {
        rowText: (item) => <TextRow name={item?.employment?.department?.name ? item?.employment?.department?.name : '--'} textWidth={8} />,
    },
    { rowText: (item) => <TextRow name={item?.employment?.title?.name} textWidth={8} /> },
    { rowText: (item) => <TextRow name={item?.email} /> },
    { rowText: (item) => <PhoneRow phone={item?.phone} /> },
    { rowText: (item) => <DateRow date={item?.hiredDate} /> },
    canReadTags() && {
        rowText: (item) => <TagComponent userInfo={item} module={tagEnums.STAFF} requestParams={requestParams} />,
        notClickable: true,
    },
    { rowText: (item) => <StatusCard status={item?.status} /> },
    { rowText: (item) => <NavigateCalendar staff={item} />, notClickable: true },
];

export const ACTION_TYPE = 'GET_ADMINS';

export const staffNotYet = {
    title: 'No Staff Added Yet',
    subTitle: 'Start by adding staff members to manage your clients and services.',
    image: Images.noClientYet,
};
